import { Component, OnInit, inject } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {VwuiModalRef} from '@recognizebv/vwui-angular';
import {ProjectService, TranslationService, UserService} from '../../services';
import {FormUtil} from '../../utils';

@Component({
    standalone: false,
    selector: 'app-create-project-modal',
    templateUrl: './create-project-modal.component.html'
})
export class CreateProjectModalComponent implements OnInit {
    private projectService = inject(ProjectService);
    private userService = inject(UserService);
    modalRef = inject(VwuiModalRef);
    private translationService = inject(TranslationService);


    public form = new FormGroup({
        name: new FormControl('', Validators.required),
        address: new FormControl('', Validators.required),
        city: new FormControl('', Validators.required),
        country: new FormControl('NL', Validators.required),
        companyName: new FormControl('', Validators.required)
    });
    public loading = false;
    public companyNames: string[];
    public countries: {id: string; name: string}[];

    constructor() {
        const translationService = this.translationService;

        this.countries = translationService.getCountriesAsKeyValue();
    }

    ngOnInit(): void {
        this.userService.getUserInfo().then((userInfo) => {
            this.companyNames = userInfo.getCompanyNamesForManuallyAddingProjects();
        });
    }

    async submit() {
        this.loading = true;

        try {
            FormUtil.validate(this.form);

            if (this.form.valid) {
                await this.projectService.createProject(this.form.value);
                this.modalRef.close(true);
            }
        } finally {
            this.loading = false;
        }
    }
}
